import React from 'react';

import Button from '@/components/ui/buttons/Button';
import ErrorList from '@/components/ui/forms/ErrorList';
import { type Student } from '@/interfaces/student';

import styles from './InviteEmailConfirmForm.module.scss';

interface Props {
  student: Student;
  email: string;
  onBack: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
  apiError?: string;
}

const InviteEmailConfirmForm: React.FC<Props> = ({
  student,
  email,
  onBack,
  onSubmit,
  isLoading = false,
  apiError,
}) => (
  <div className={styles.InviteEmailConfirmForm}>
    <div className={styles.InviteEmailConfirmForm__Description}>
      以下の内容で招待メールを送信します。
    </div>
    <div className={styles.InviteEmailConfirmForm__Content}>
      <div className={styles.InviteEmailConfirmForm__Item}>
        <div className={styles.InviteEmailConfirmForm__ItemLabel}>生徒名</div>
        <div className={styles.InviteEmailConfirmForm__ItemValue}>
          {student.name}
        </div>
      </div>
      <div className={styles.InviteEmailConfirmForm__Item}>
        <div className={styles.InviteEmailConfirmForm__ItemLabel}>
          <span className={styles.InviteEmailConfirmForm__ItemLabelPC}>
            メールアドレス
          </span>
          <span className={styles.InviteEmailConfirmForm__ItemLabelSP}>
            招待する方のメールアドレス
          </span>
        </div>
        <div className={styles.InviteEmailConfirmForm__ItemValue}>{email}</div>
      </div>
    </div>
    {apiError && (
      <ErrorList
        errors={[apiError]}
        className={styles.InviteEmailConfirmForm__Errors}
      />
    )}
    <div className={styles.InviteEmailConfirmForm__Buttons}>
      <Button
        type="button"
        color="primary"
        size="m"
        onClick={onSubmit}
        disabled={isLoading}
      >
        招待メールを送信する
      </Button>
      <Button type="button" color="link" size="m" onClick={onBack}>
        ＜戻る
      </Button>
    </div>
  </div>
);

export default InviteEmailConfirmForm;
